import { render, staticRenderFns } from "./RepseRequestTable.vue?vue&type=template&id=72e0076f"
import script from "./RepseRequestTable.vue?vue&type=script&lang=js"
export * from "./RepseRequestTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports